export enum HelpEvents {
  clickLinkOferta = 'click_link_oferta',
}
